define(['jquery'], function ($) {

	var ERVil8n = function () {
		$.datepicker.regional.sv = {
			closeText: 'Stäng',
			prevText: '',
			nextText: '',
			currentText: 'Idag',
			monthNames: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni',
			'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
			monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun',
			'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
			dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
			dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
			dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
			weekHeader: 'Ve',
			firstDay: 1,
			isRTL: false,
			showMonthAfterYear: false,
			yearSuffix: '',
			dateFormat: 'yy-mm-dd'
		};

		$.datepicker.regional.da = {
			closeText: 'Luk',
			prevText: '',
			nextText: '',
			currentText: 'Idag',
			monthNames: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni',
			'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
			monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun',
			'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
			dayNames: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
			dayNamesShort: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
			dayNamesMin: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
			weekHeader: 'Uge',
			firstDay: 1,
			isRTL: false,
			showMonthAfterYear: false,
			yearSuffix: '',
			dateFormat: 'dd-mm-yy'
		};

		$.datepicker.regional.fi = {
			dateFormat: 'dd-mm-yy'
		};

		$.datepicker.regional.is = {
			dateFormat: 'dd-mm-yy'
		};

		//norway
		$.datepicker.regional.nb = {
			dateFormat: 'yy-mm-dd'
		};
	};

	return ERVil8n;
});